<script>
import { mapState } from "vuex";
import Client from "../../api/AxiosClient";

export default {
    data: () => ({
        fileRecords: [],
        fileRecordsForUpload: [], // maintain an upload queue
        uploadUrl: `${Client.defaults.baseURL}/private/files`,
        uploadHeaders: { 'x-access-token': localStorage.getItem('accessToken') ? localStorage.getItem('accessToken').toString() : ''},
        fileIds: []

    }),
    methods: {
        async uploadFiles() {
            this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload, function createFormData(fileData){
                var formData = new FormData();
                formData.append('files', fileData.file); // this is important! - the actual file for upload
                return formData; // edit: fixed. Thanks to Chauhan-Nitesh for the comment below
            }).then(response => {
                this.fileIds = response.map(item => {
                    return item.data.fileIds.join(',')
                })
                
            }).catch(e => {
                console.log(e)
            });
           
        },
        onBeforeDelete: function (fileRecord) {
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
            // queued file, not yet uploaded. Just remove from the arrays
            this.fileRecordsForUpload.splice(i, 1);
            var k = this.fileRecords.indexOf(fileRecord);
            if (k !== -1) this.fileRecords.splice(k, 1);
            } else {
                this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
            }
        },
        filesSelected: function (fileRecordsNewlySelected) {
            var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
            this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
        },
        done: function() {
            console.log('done')
            console.log(this.fileIds)
        }

    },
    computed: {
        ...mapState("auth", ["AppActiveUser"]),
    },
    
}
</script>
<template>
    <div class="upload-file-component">
        <VueFileAgent
            ref="vueFileAgent"
            :theme="'list'"
            :multiple="true"
            :deletable="true"
            :maxSize="'50MB'"
            :maxFiles="10"
            :helpText="'Click vào đây để chọn file tải lên'"
            :errorText="{
                type: 'Loại file không được hỗ trợ',
                size: 'Kích thước file tải lên quá lớn, vượt giới hạn 100 MB',
            }"
            @beforedelete="onBeforeDelete($event)"
            @select="filesSelected($event)"
            v-model="fileRecords"
        />
        <!-- <CRow class="center">
            <vs-button square success :disabled="!fileRecordsForUpload.length" @click="uploadFiles()"><i class="bx bx-save"></i> &nbsp; Bắt đầu tải {{ fileRecordsForUpload.length }} files</vs-button>
            <vs-button square danger @click="done"><i class="bx bx-save"></i> &nbsp; Xong</vs-button>
        </CRow> -->
        
    </div>
</template>

<style lang="scss">
    .upload-file-component {
        .vue-file-agent .file-progress.file-progress-done {
            width: calc(100% - 55px) !important;
            border-radius: 0;
        }
        .vue-file-agent.file-input-wrapper {
            min-height: 200px;
        }
    }
</style>